const GovernmentPublicationsFilters = [
  {
    name: 'Department',
    pages: ['GovernmentPublications'],
    type: 'membership',
    subtype: 'DepartmentSelectType',
    searchState: 'always',
    filterName: 'from',
    options: [],
    prefix: 'dep',
    optionSelected: '',
  },
];

export default GovernmentPublicationsFilters;
